<template>
  <a
    :href="url"
    :rel="isExternalLink ? 'external' : 'next'"
    :target="isExternalLink ? '_blank' : 'self'"
    class="button button--xl button--info"
  >
    <span>
      {{ linkLabel }}
    </span>
    <i class="icon">
      <Icon name="fa6-solid:arrow-up-right-from-square" />
    </i>
  </a>
</template>

<script setup lang="ts">
import type { MultilinkStoryblok } from '~/types/storyblok'

const props = withDefaults(
  defineProps<{
    link?: MultilinkStoryblok
    linkLabel?: string
    defaultLabel?: string
  }>(),
  {
    link: undefined,
    linkLabel: undefined,
    defaultLabel: 'Find out more',
  },
)

const linkLabel = computed(() => props?.linkLabel || props.defaultLabel)
const isExternalLink = computed(() => props.link?.linktype === 'url')
const url = computed(() =>
  isExternalLink.value
    ? props.link?.url
    : props.link?.story
      ? '/' + props.link.story.full_slug
      : '',
)
</script>
